export const GET_METADATA_DATASCORING_SUCCESS =
  'GET_METADATA_DATASCORING_SUCCESS';
export const GET_METADATA_DATASCORING_FAILURE =
  'GET_METADATA_DATASCORING_FAILURE';

export const GET_METADATA_DATASCORING_FORM_VIEW_SUCCESS =
  'GET_METADATA_DATASCORING_FORM_VIEW_SUCCESS';
export const GET_METADATA_DATASCORING_FORM_VIEW_FAILURE =
  'GET_METADATA_DATASCORING_FORM_VIEW_FAILURE';

export const GET_METADATA_DATASCORING_SUBFORM_VIEW_SUCCESS =
  'GET_METADATA_DATASCORING_SUBFORM_VIEW_SUCCESS';
export const GET_METADATA_DATASCORING_SUBFORM_VIEW_FAILURE =
  'GET_METADATA_DATASCORING_SUBFORM_VIEW_FAILURE';

export const GET_METADATA_DATASCORING_EVALUATION_GROUP_VIEW_SUCCESS =
  'GET_METADATA_DATASCORING_EVALUATION_GROUP_VIEW_SUCCESS';
export const GET_METADATA_DATASCORING_EVALUATION_GROUP_VIEW_FAILURE =
  'GET_METADATA_DATASCORING_EVALUATION_GROUP_VIEW_FAILURE';

export const GET_METADATA_DATASCORING_DATAPOINTS_VIEW_SUCCESS =
  'GET_METADATA_DATASCORING_DATAPOINTS_VIEW_SUCCESS';
export const GET_METADATA_DATASCORING_DATAPOINTS_VIEW_FAILURE =
  'GET_METADATA_DATASCORING_DATAPOINTS_VIEW_FAILURE';
export const ADD_METADATA_DATASCORING_FAILURE =
  'ADD_METADATA_DATASCORING_FAILURE';
export const ADD_METADATA_DATASCORING_SUCCESS =
  'ADD_METADATA_DATASCORING_SUCCESS';
export const POST_EVALDATA_BY_IDS_FAILURE = 'POST_EVALDATA_BY_IDS_FAILURE';
export const POST_EVALDATA_BY_IDS_SUCCESS = 'POST_EVALDATA_BY_IDS_SUCCESS';

export const GET_SUB_SCORING_GROUPS_INFO_FAILURE =
  'GET_SUB_SCORING_GROUPS_INFO_FAILURE';
export const GET_SUB_SCORING_GROUPS_INFO_SUCCESS =
  'GET_SUB_SCORING_GROUPS_INFO_SUCCESS';
